import { useEffect, useState } from 'react';
import { useField, useFormikContext } from 'formik';
export function useFilter(name) {
    const { status } = useFormikContext();
    const [field, meta, helpers] = useField(`filters.${name}`);
    const [, , offsetHelpers] = useField('offset');
    const { value, name: path } = field;
    const [stagedValue, setStagedValue] = useState(value);
    useEffect(() => {
        setStagedValue(value);
    }, [value]);
    const operator = Object.keys(value || {})[0];
    const hasValue = Boolean(operator && value && value[operator] != null);
    const isDraft = !hasValue && !meta.touched;
    const isTouched = meta.touched && (status === null || status === void 0 ? void 0 : status.showDirty);
    const hasStagedValues = value !== stagedValue;
    /** Commits the staged value to shared form state and resets the offset. */
    const commitValue = () => {
        helpers.setValue(stagedValue);
        helpers.setTouched(true);
        offsetHelpers.setValue(0);
    };
    /** Stages and commits a value in one operation, updating shared form state directly. */
    const applyValue = (newValue) => {
        setStagedValue(newValue);
        helpers.setValue(newValue);
        helpers.setTouched(true);
        offsetHelpers.setValue(0);
    };
    const resetValue = () => {
        setStagedValue(undefined);
        helpers.setValue(undefined);
        helpers.setTouched(true);
        offsetHelpers.setValue(0);
    };
    return {
        path,
        value,
        stagedValue,
        isDraft,
        isTouched,
        hasValue,
        operator,
        setStagedValue,
        commitValue,
        applyValue,
        resetValue,
        name: field.name,
        hasStagedValues,
    };
}
